import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  description = "",
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  destructive = false,
  children = null,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxWidth: 400,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 16,
          fontWeight: 600,
          fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
          color: "hsl(150 30% 12%)",
          pb: 0.5,
        }}
      >
        {title}
      </DialogTitle>
      {(description || children) && (
        <DialogContent>
          {description && (
            <DialogContentText sx={{ fontSize: 14, color: "hsl(150 10% 46%)" }}>
              {description}
            </DialogContentText>
          )}
          {children}
        </DialogContent>
      )}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          disableRipple
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontSize: 14,
            fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
            color: "hsl(150 10% 46%)",
            borderRadius: "8px",
            height: "auto",
            px: 2,
            "&:hover": { backgroundColor: "hsl(140 8% 90%)" },
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          disableRipple
          disableElevation
          variant="contained"
          onClick={onConfirm}
          sx={{
            textTransform: "none",
            minHeight: 0,
            height: "auto",
            fontSize: 14,
            fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
            borderRadius: "8px",
            px: 2,
            backgroundColor: destructive ? "hsl(0 72% 51%)" : "hsl(150 38% 17%)",
            color: destructive ? "#fff" : "hsl(80 97% 72%)",
            "&:hover": {
              backgroundColor: destructive ? "hsl(0 72% 45%)" : "hsl(150 38% 14%)",
            },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
